import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=2fe1d58d&scoped=true&"
import script from "./admin.js?vue&type=script&lang=js&"
export * from "./admin.js?vue&type=script&lang=js&"
import style0 from "./admin.css?vue&type=style&index=0&id=2fe1d58d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1d58d",
  null
  
)

export default component.exports